import React from 'react';
import { Popup } from 'semantic-ui-react';

const CircleIndicator = ({ 
  letter, 
  color = '#0099ff', 
  tooltip = '', 
  size = 20,
  className = '',
  style = {}
}) => {
  const circleStyle = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: `${Math.max(10, size * 0.6)}px`,
    fontWeight: 'bold',
    cursor: 'pointer',
    flexShrink: 0
  };

  const Circle = (
    <div 
      style={{...circleStyle, ...style}} 
      className={className}
    >
      {letter}
    </div>
  );

  if (tooltip) {
    return (
      <Popup
        trigger={Circle}
        content={tooltip}
        inverted
        position="top center"
        size="tiny"
      />
    );
  }

  return Circle;
};

export default CircleIndicator; 